// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#game {\n  position: absolute;\n  background: #000;\n  display: block;\n  width: 100%;\n  height: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
